import { Grid, ProgressBar } from "antd-mobile";
import styled from "styled-components";
import { IMAGE_PREFIX_URL } from "../../utils/constants";
import { useIntl } from "react-intl";
export default function ECards({ list, onClick = () => {} }) {
  const intl = useIntl();
  return (
    <Grid columns={2} gap={8}>
      {(list || []).map((e) => (
        <Grid.Item key={e.collection_id}>
          <Item
            onClick={() => {
              onClick(e);
            }}
          >
            <Title>
              {new Array(e.level || 0).fill("").map((e, i) => (
                <img key={i} src="/image/foot.png" width={8} alt="foot" />
              ))}{" "}
              {e.collection_name}
            </Title>
            <div style={{ position: "relative" }}>
              <Image >
                <img
                  src={IMAGE_PREFIX_URL + "/images/" + e.cover}
                  alt={e.collection_id}
                />
              </Image>
              {e.stock <= e.sales ?<Mask>
                <img  src="image/empty.svg"  alt="empty"/>
              </Mask>:null}
            </div>

            {/* <Sales>Mint {e.sales} / {e.stock}</Sales> */}
            <Sales>
              {intl.formatMessage({ id: "发行量" })}{" "}
              <span style={{ float: "right" }}>{e.stock}</span>
            </Sales>
            {/* <Process>
              {" "}
              <ProgressBar percent={(e.sales / e.stock) * 100} />
            </Process> */}
            <ItemFooter>
              <Grid columns={7} gap={8}>
                <Grid.Item span={4} style={{ whiteSpace: "nowrap" }}>
                  <img src="/image/RB.png" alt="runbit icon" />{" "}
                  <span style={{ verticalAlign: "middle" }}>{e.price1}</span>
                </Grid.Item>
                <Grid.Item span={3} style={{ whiteSpace: "nowrap" }}>
                  <img src="/image/chip.png" alt="runbit chip" />{" "}
                  <span style={{ verticalAlign: "middle" }}>{e.price0}</span>
                </Grid.Item>
              </Grid>
            </ItemFooter>
          </Item>
        </Grid.Item>
      ))}
    </Grid>
  );
}

const Item = styled.div`
  text-align: center;
  background-color: #fff;
  border-radius: 2.2rem;
`;
const Title = styled.div`
  min-width: 50%;
  display: inline-block;
  margin: 0 auto 2rem;
  background: #f4f5f6;
  border-radius: 0rem 0rem 1rem 1rem;
  padding: 0.6rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.3rem;

  color: #000000;
`;

const ItemFooter = styled.div`
  background: #fffcdc;
  border-radius: 0rem 0rem 2.2rem 2.2rem;
  padding: 1.1rem 1.5rem;
  text-align: left;
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 1.4rem;
  color: #000000;

  img {
    width: 2rem;
    display: inline-block;
    vertical-align: middle;
  }
`;

const Image = styled.div`
  min-height: 12rem;
  img {
    width: 60%;
  }
`;

const Sales = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.3rem;

  color: #969696;
  text-align: left;
  width: 85%;
  margin: auto;
  margin-bottom: 1rem;
`;

const Process = styled.div`
  width: 80%;
  margin: 4px auto 1rem;
`;

const Mask = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  img {
    width: 80%;
  }
`;
